import { render } from "./PaymentModal.vue?vue&type=template&id=cabae05c&scoped=true&ts=true"
import script from "./PaymentModal.vue?vue&type=script&lang=ts"
export * from "./PaymentModal.vue?vue&type=script&lang=ts"

import "./PaymentModal.vue?vue&type=style&index=0&id=cabae05c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cabae05c"]])

export default __exports__